export default __webpack_public_path__ + "static/media/gc-baseball@2x.cef49c76.png";